import React from 'react';
import { Box } from '@chakra-ui/core';
import { Cell } from 'react-table';
import { useTranslation } from 'react-i18next';
import { CandidateSearchResponseType, CandidateStatus } from '../CandidateSearchTypes';

interface StatusCellProps {
  cell: Cell<CandidateSearchResponseType>;
}

// istanbul ignore next
const getStatusLabel = (label: string, t: (key: string) => string) => {
  switch (label) {
    case CandidateStatus.Dismissed:
      return t('candidateStatus.DISMISSED');
    case CandidateStatus.Hired:
      return t('candidateStatus.HIRED');
    case CandidateStatus.HireInReview:
      return t('candidateStatus.HIRE_IN_REVIEW');
    case CandidateStatus.HiredOnAnotherPosition:
      return t('candidateStatus.HIRED_ON_ANOTHER_POSITION');
    case CandidateStatus.NotLookingForWork:
      return t('candidateStatus.NOT_LOOKING_FOR_WORK');
    case CandidateStatus.AppointmentRequested:
      return t('candidateStatus.APPOINTMENT_REQUESTED');
    case CandidateStatus.AppointmentAccepted:
      return t('candidateStatus.APPOINTMENT_ACCEPTED');
    case CandidateStatus.AppointmentCancelled:
      return t('candidateStatus.APPOINTMENT_CANCELLED');
    case CandidateStatus.AppointmentDeclined:
      return t('candidateStatus.APPOINTMENT_DECLINED');
    case CandidateStatus.ContactRequested:
      return t('candidateStatus.CONTACT_REQUESTED');
    case CandidateStatus.ContactRequestAccepted:
      return t('candidateStatus.CONTACT_REQUEST_ACCEPTED');
    case CandidateStatus.ContactRequestDeclined:
      return t('candidateStatus.CONTACT_REQUEST_DECLINED');
    case CandidateStatus.AppointmentReschedulingNeeded:
      return t('candidateStatus.APPOINTMENT_RESCHEDULING_NEEDED');
    case CandidateStatus.OfferMade:
      return t('candidateStatus.OFFER_MADE');
    case CandidateStatus.OfferRejected:
      return t('candidateStatus.OFFER_REJECTED');
    case CandidateStatus.OfferRevoked:
      return t('candidateStatus.OFFER_REVOKED');
    case CandidateStatus.Bookmarked:
      return t('candidateStatus.BOOKMARKED');
    case CandidateStatus.Liked:
      return t('candidateStatus.LIKED');
    case CandidateStatus.InterestRevoked:
      return t('candidateStatus.INTEREST_REVOKED');
    case CandidateStatus.Unhired:
      return t('candidateStatus.UNHIRED');
    case CandidateStatus.Blacklisted:
      return t('candidateStatus.BLACKLISTED');
    default:
      return '-';
  }
};

export const StatusCell: React.FC<StatusCellProps> = ({ cell }) => {
  const { t } = useTranslation('candidateSearch');
  const { statusDetails } = cell?.row?.original;

  return (
    <Box fontSize="14px" fontWeight={400} textTransform="capitalize">
      {statusDetails?.status && getStatusLabel(statusDetails.status, t)}
    </Box>
  );
};
